/* Photos des chantiers EVOLINK (public/img/ch-*.webp) + quelques photos libres de droits (Unsplash)
   pour les domaines sans photo maison (fibre, PAC, IRVE, centrales au sol…). */
const EVO = (n) => `${process.env.PUBLIC_URL}/img/${n}.webp`;
const U = (id, w = 1400) => `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=75`;

export const STOCK = {
  electricien: U('1615774925655-a0e97fc85c14'),
  electricienCablage: U('1621905251189-08b45d6a269e'),
  pac: U('1776860150305-108ed577d7d4'),
  irve: U('1593941707882-a5bba14938c7'),
  enr: U('1723640103357-cd8e8f0cd10c'),
  fibreBaie: U('1594915440248-1e419eba6611'),
  fibreAerien: U('1759542877886-39d81e8f2eee'),
  fibreFils: U('1594915854088-2128db6a8db5'),
  centraleSol: U('1680355065203-43ad84bb6e69'),
  centraleSol2: U('1509391366360-2e959784a276'),
  poseursToit: EVO('ch-pose-modules'),  // photo chantier EVOLINK
  poseursToit2: EVO('ch-toiture-plate'),  // photo chantier EVOLINK
  poseurModule: EVO('ch-hangar-campagne'),  // photo chantier EVOLINK
  chefEquipe: EVO('ch-toiture-filets'),  // photo chantier EVOLINK
  cableurModule: EVO('ch-onduleurs'),  // photo chantier EVOLINK
  entrepotsSolaires: EVO('ch-toiture-industrielle'),  // photo chantier EVOLINK
  eclairage: U('1626006846694-f0852fa032f1'),
};

export default STOCK;
